export function initTabs() {
    document.querySelectorAll('[data-toggle="tab"]').forEach(function (tab) {
        if (tab.dataset.initialized) return;
        tab.dataset.initialized = 'true';

        tab.addEventListener('click', function (e) {
            e.preventDefault();
            const targetSelector = this.dataset.target;
            const nav = this.closest('.nav');

            if (!nav) return;

            nav.querySelectorAll('.nav-link').forEach(link => link.classList.remove('active'));
            this.classList.add('active');

            if (targetSelector) {
                const targetContent = document.querySelector(targetSelector);
                if (targetContent) {
                    const parentContent = targetContent.parentElement;
                    if (parentContent) {
                        parentContent.querySelectorAll('.tab-content').forEach(pane => pane.classList.remove('active'));
                    }
                    targetContent.classList.add('active');
                }
            }
        });
    });
}
